const { MessagePayload } = require('client-web-app');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.web.messagePayload', deps)
  .directive('blMessagePayload', reactDirective =>
    reactDirective(MessagePayload, ['clientId', 'payload', 'isNewMessageFormattingEnabled']),
  );
